<template>
  <div slot="body">
    <bita-form ref="form">
      <div slot="body">
        <div class="row">
          <bita-input
              name="price"
              style="direction: ltr"
              label="مبلغ"
              rules="required"
              :has-thousand-seprator="true"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.price"
          />

          <bita-input
              type="text"
              name="name"
              label="نام"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.name"
          />
          <bita-input
              type="file"
              name="preview"
              id="preview"
              label="پیش نمایش"
              :rules="dataForm.id ? '' : 'required'"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.preview"
          />
          <bita-input
              type="file"
              name="file"
              id="font-file"
              label=" فایل"
              :rules="dataForm.id ? '' : 'required'"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.file"
          />

          <bita-input
              type="text"
              name="description"
              ref="priceDescription"
              label="توضیحات"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.description"
          />
          <bita-bootbutton
              type="primary transaction"
              title="ذخیره"
              icon="fa fa-check"
              btn-width="150px"
              @click.native="handleSubmit()"
          />
          <hr>
        </div>
      </div>
    </bita-form>
    <bita-grid
        ref="grid"
        :columns="gridColumns"
        :read-data="readData"
        :pageable="false"
        :batch="true"
        :resizable="true"
        :grid-server-side="true"
        :schema-data="'entity'"
        :auto-bind="false"
    />
  </div>
</template>
<script>
import { productApi } from "@/api/apiManagement.js";

export default {
  data() {
    return {
      colWidth: "col-lg-6 col-md-6 col-sm-6",
      isLoading: false,
      dataForm: {},
      product: {},
    };
  },
  computed: {
    formRef() {
      return this.$refs.form;
    },
    gridColumns() {
      return [
        {
          field: "price",
          title: "مبلغ",
          template: ({ price }) => {
            let priceClass = "text-success";

            return (
                `<span class="${priceClass}">` +
                (price ? this.$thousandSeprator(price) : " - ") +
                `</span>`
            );
          },
        },
        {
          field: "name",
          title: "نام",
        },
        {
          title: "عملیات",
          command: this.getGridColumns(),
          with: 120,
        },
      ];
    },
  },
  methods: {
    init(product) {
      this.product = product;
      this.$emit("is-loading", true);
      this.$showModal("#productPricesModal");
      this.loadData();
    },
    setInitialValue(_data) {
      this.product = _data;
      this.$emit("is-loading", true);
      if (this.product.id) this.loadData();
    },
    getGridColumns() {
      let commands = [];
      if (this.$acl.can("edit", "products")) {
        commands.push({
          text: "edit",
          click: this.edit,
          template: this.gridButtons.edit,
        });
        commands.push({
          text: "delete",
          click: this.delete,
          template: this.gridButtons.delete,
        });
      }
      return commands;
    },
    readData(e) {
      productApi.getProductPrices(this.product.id)
          .then(({ data }) => {
            e.success(data);
            this.$emit("on-reload");
          })
          .catch(() => {
            e.success([]);
          })
          .finally(() => {
            this.$emit("is-loading", false);
          });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.isLoading = true;
          let data = this.$getFormData(this.dataForm);

          if(data.has('file')) {
            data.delete('file')
            data.append('file', document.getElementById('font-file').files[0])
          }

          if(data.has('preview')) {
            data.delete('preview')
            data.append('preview', document.getElementById('preview').files[0])
          }

          if(data.has('id')) {
            data.delete('id')
            productApi
                .updateProductPrice(this.dataForm.id, data)
                .then(({ data }) => {
                  this.reset();
                })
                .finally(() => {
                  this.isLoading = false;
                  this.loadData();
                });
          } else {
            productApi
                .addProductPrice(this.product.id, data)
                .then(({ data }) => {
                  this.reset();
                })
                .finally(() => {
                  this.isLoading = false;
                  this.loadData();
                });
          }
        }
      });
    },
    edit(e) {
      let item = this.$refs.grid.getSelectedGridRow(e);
      this.dataForm = {id: item.id, name: item.name, price: item.price, description: item.description}
    },
    delete(e) {
      let role = this.$refs.grid.getSelectedGridRow(e);
      this.$alert("question", `آیا از حذف ${role.name} اطمینان دارید؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          productApi
              .deleteProductPrice(role.id)
              .then((res) => {
                this.$izitoast("success", "با موفقیت حذف شد", "موفق");
                this.loadData();
              })
              .finally(() => {
                this.isLoadingGrid = false;
              });
        }
      });
    },
    save() {
      return new Promise((resolve, reject) => {
        resolve(true);
      });
    },
    reset() {
      this.dataForm = {};
      this.$refs.form.reset();
    },
    setErrors(_errors) {
      this.$refs.form.setErrors(_errors);
    },
  },
};
</script>
<style scoped>
img {
  width: 75px;
  max-height: 120px;
}
.custom-file-label {
  padding: 0.5rem 4.2rem 0 0;
}
.center-align {
  text-align: center;
}
.btn-primary.transaction {
  margin: 25px auto 0 auto !important;
  height: 39px;
}
</style>
